import { adminAreaQueryKeys as e } from "./adminAreaQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminAreaApi as n } from "@maat/api-main";
//#region src/areas/admin/useAdminPlaceSearchQuery.ts
var r = (r, i) => t({
	queryKey: e.placeSearch(r ?? "", i),
	queryFn: () => n.searchPlaces(r, i),
	enabled: !!r && i.trim().length > 0
});
//#endregion
export { r as useAdminPlaceSearchQuery };
